import { useState } from 'react'
import FormsyInput from '@components/Textfield/withFormsy'
import Select from '@components/Select/RequiredSelectWithFormsy'
import { countries, getStates, getStateValue, getCountryValue } from 'shared/states'

import { withTranslate } from '@i18n/utils'

export const AddressFormBr = withTranslate(
    ({
        address1,
        address2,
        city,
        postalCode,
        addressee,
        state,
        country = window.COUNTRY_PURCHASE_FLOW,
        prefix = '',
        translate: t,
        isStateFieldExcluded,
        withAddressee,
        district,
        streetNumber,
    }) => {
        const [selectedCountry, setSelectedCountry] = useState(country)

        return (
            <>
                {withAddressee && (
                    <div className="row">
                        <div className="col-md-6">
                            <FormsyInput
                                value={addressee}
                                name={`${prefix}.addressee`}
                                required
                                placeholder={t('dashboard.account.addressee')}
                                validationError={t('dashboard.account.addressee.invalid')}
                                autoComplete="name"
                            />
                        </div>
                    </div>
                )}
                <div className="row">
                    <div className="col-md-6">
                        <FormsyInput
                            name={`${prefix}.address1`}
                            value={address1}
                            placeholder={t('dashboard.account.address1')}
                            required
                            validationError={t('dashboard.account.address1.invalid')}
                            autoComplete="address-line1"
                        />
                    </div>
                    <div className="col-md-6">
                        <FormsyInput
                            name={`${prefix}.address2`}
                            value={address2}
                            placeholder={t('dashboard.account.address2')}
                            autoComplete="address-line2"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <FormsyInput
                            name={`${prefix}.streetNumber`}
                            value={streetNumber}
                            required
                            pattern="^[0-9a-zA-Z\s]+$"
                            validations={{ matchRegexp: /^[0-9a-zA-Z\s]+$/ }}
                            placeholder={t('dashboard.account.streetNumber')}
                            validationError={t('dashboard.account.streetNumber.invalid')}
                        />
                    </div>
                    <div className="col-md-6">
                        <FormsyInput
                            name={`${prefix}.postalCode`}
                            value={postalCode}
                            uppercase
                            placeholder={t('dashboard.account.postalCode')}
                            required
                            validationError={t('dashboard.account.postalCode.ca.invalid')}
                            autoComplete="postal-code"
                        />
                    </div>
                    <div className="col-md-6">
                        <FormsyInput
                            name={`${prefix}.city`}
                            value={city}
                            placeholder={t('dashboard.account.city')}
                            required
                            validationError={t('dashboard.account.city.invalid')}
                            autoComplete="address-level2"
                        />
                    </div>
                    {!isStateFieldExcluded && (
                        <div className="col-md-6 form-group">
                            <Select
                                options={getStates(selectedCountry)}
                                isSearchable={true}
                                getSelectValue={getStateValue(selectedCountry)}
                                value={state}
                                name={`${prefix}.state`}
                                placeholder={t('dashboard.account.state')}
                                required
                            />
                        </div>
                    )}
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <FormsyInput
                            name={`${prefix}.district`}
                            value={district}
                            placeholder={t('dashboard.account.district')}
                            required
                            pattern="^[0-9a-zA-Z\s]+$"
                            validations={{ matchRegexp: /^[0-9a-zA-Z\s]+$/ }}
                            validationError={t('dashboard.account.district.invalid')}
                        />
                    </div>
                    <div className="col-md-6 form-group">
                        <Select
                            options={countries}
                            onChange={setSelectedCountry}
                            isSearchable={true}
                            getSelectValue={getCountryValue}
                            value={selectedCountry}
                            name={`${prefix}.country`}
                            placeholder={t('dashboard.account.country')}
                            required
                        />
                    </div>
                </div>
            </>
        )
    }
)
